export default "__VITE_ASSET__jqRcOSX7hhoH$dQ54uZfPQ__"